import ApiDrivenModel from "./ApiDrivenModel"
export default class Organization extends ApiDrivenModel {
	static ENDPOINT = "/Organization";
	
	async linkAssociate(associate) {
		try {
			const { success, result } = await Organization.Call({
				name: "Link_Associate",
				payload: {
					associate,
					organization: this.id,
				}
			});

			if (success) {
				const { success } = result;
				return { success };
			}
		} catch ( /** @type CustomError */ e) {
			console.warn("Failed to link associate", e.data);
		}

		return { success: false };
	}
}
